import React from 'react';
import { ib } from './classNames';

const IMPACT_TEXT = '상황판, 직원 요약, 마케터 1:1 청구의 반영장수 계산에 적용됩니다.';

function formatWeight(value) {
  const n = Number(value ?? 1);
  if (!Number.isFinite(n)) return '1';
  return n.toLocaleString('ko-KR', { maximumFractionDigits: 4 });
}

export function ProductWeightNotice() {
  return (
    <div className="border-b border-[var(--border)] bg-sky-50/70 px-3.5 py-2 text-[11px] leading-relaxed text-sky-800 dark:bg-sky-950/30 dark:text-sky-100">
      <span className="font-extrabold">환산장수</span>는 상품명과 별개로 장수 계산에 쓰는 기준입니다.
      적용 시작일 이후의 상황판, 직원 요약, 마케터 1:1 청구 계산에 반영됩니다.
    </div>
  );
}

export function ProductWeightControl({
  ticket,
  isEditing,
  editWeightDate,
  setEditWeightDate,
  editWeightValue,
  setEditWeightValue,
  editWeightMemo,
  setEditWeightMemo,
  saving,
  saveTicketWeight,
  cancelEditWeight,
  startEditWeight,
  openWeightHistory,
}) {
  if (!isEditing) {
    const effectiveFrom = ticket.current_weight_effective_from;
    const handleOpen = () => {
      if (typeof openWeightHistory === 'function') {
        openWeightHistory(ticket);
        return;
      }
      startEditWeight(ticket);
    };
    return (
      <button
        type="button"
        className="inline-flex flex-shrink-0 items-center gap-1 rounded-full border border-sky-200 bg-sky-50 px-2 py-0.5 text-[10px] font-extrabold text-sky-700 dark:border-sky-800 dark:bg-sky-900/25 dark:text-sky-200"
        onClick={handleOpen}
        title={`${IMPACT_TEXT}${effectiveFrom ? ` 현재 기준: ${effectiveFrom}부터` : ''}`}
      >
        <span>환산장수 {formatWeight(ticket.current_weight)}장</span>
        {effectiveFrom && <span className="text-[9px] font-bold opacity-70">{effectiveFrom}~</span>}
      </button>
    );
  }

  return (
    <span className="flex w-full flex-wrap items-end justify-end gap-1.5 rounded-lg border border-sky-200 bg-sky-50/80 p-2 dark:border-sky-800 dark:bg-sky-950/35 sm:w-auto sm:min-w-[330px]">
      <label className="flex flex-col gap-0.5 text-[10px] font-bold text-sky-700 dark:text-sky-200">
        <span>적용 시작일</span>
        <input
          type="date"
          value={editWeightDate}
          onChange={(e) => setEditWeightDate(e.target.value)}
          className="w-[126px] rounded-md border border-sky-300 bg-white px-1.5 py-1 text-[11px] font-bold text-[var(--text)] outline-none dark:border-sky-700 dark:bg-pine-800"
        />
      </label>
      <label className="flex flex-col gap-0.5 text-[10px] font-bold text-sky-700 dark:text-sky-200">
        <span>환산장수</span>
        <input
          inputMode="decimal"
          value={editWeightValue}
          onChange={(e) => setEditWeightValue(e.target.value.replace(/[^0-9.]/g, ''))}
          className="w-20 rounded-md border border-sky-300 bg-white px-1.5 py-1 text-right text-xs font-extrabold text-sky-700 outline-none dark:border-sky-700 dark:bg-pine-800 dark:text-sky-200"
          placeholder="장수"
        />
      </label>
      <label className="flex min-w-[130px] flex-1 flex-col gap-0.5 text-[10px] font-bold text-sky-700 dark:text-sky-200">
        <span>변경 사유</span>
        <input
          value={editWeightMemo}
          onChange={(e) => setEditWeightMemo(e.target.value)}
          className="w-full rounded-md border border-[var(--border)] bg-white px-1.5 py-1 text-[11px] text-[var(--text)] outline-none dark:bg-pine-800"
          placeholder="예: 조식VIP 5장 환산"
        />
      </label>
      <button className={ib('ok', 'h-[24px] px-2')} onClick={() => saveTicketWeight(ticket.id)} disabled={saving}>저장</button>
      <button className={ib('cancel', 'h-[24px] px-2')} onClick={cancelEditWeight}>취소</button>
      <span className="basis-full text-right text-[10px] font-semibold text-sky-700/80 dark:text-sky-100/75">
        {IMPACT_TEXT}
      </span>
    </span>
  );
}
